export default "__VITE_ASSET__DncHqAKS__"